import { TranslocoService } from "@jsverse/transloco";
import { ApiCompleteSignInError, ApiSignInFailureKind } from "../../apiClient/models";

// Magic Transloco strings to detect dynamic keys:
/**
 * t(app.sign-in-redirect.failureReason.handshakeFailed)
 * t(app.sign-in-redirect.failureReason.invalidEmail)
 * t(app.sign-in-redirect.failureReason.unableToRetrieveMicrosoftAccountInfo)
 * t(app.sign-in-redirect.failureReason.userInfoNotSyncedFromFlow)
 * t(app.sign-in-redirect.failureReason.unableToCreateUser)
 * t(app.sign-in-redirect.failureReason.unableToCompleteSignIn)
 * t(app.sign-in-redirect.failureReason.disallowedInternalDomainSignUp)
 */
export function getTranslatedSignInFailure(transloco: TranslocoService, reason: ApiSignInFailureKind): string {
  return transloco.translate(`app.sign-in-redirect.failureReason.${reason}`);
}

export function isCompleteSignInError(errorBody: unknown): errorBody is ApiCompleteSignInError {
  return (
    typeof errorBody === "object" &&
    errorBody !== null &&
    "success" in errorBody &&
    "reason" in errorBody &&
    typeof errorBody.success === "boolean"
  );
}
